export let env, socketServer, apiServer, peerServerHost, peerServerPort, peerServerSecure;

switch (window.location.hostname) {
  case 'localhost':
    env = 'dev';
    apiServer = 'http://localhost:9000';
    peerServerHost = '/';
    peerServerPort = 9500;
    peerServerSecure = false;
    break;
  case 'staging.minglespace.app':
    env = 'staging';
    socketServer = 'https://staging-socket.minglespace.app';
    apiServer = 'https://staging.api.minglespace.app';
    peerServerHost = 'staging.minglespace.app';
    peerServerPort = 9550;
    peerServerSecure = true;
    break;
  case 'minglespace.app':
    env = 'production';
    socketServer = 'https://socket.minglespace.app';
    apiServer = 'https://socket.minglespace.app';
    peerServerHost = 'socket.minglespace.app';
    peerServerPort = 9600;
    peerServerSecure = true;
    break;
}
